import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function HeroSection() {
  const [selectedCategory, setSelectedCategory] = useState('');

  const handleCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      setSelectedCategory(url);
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden pt-16 md:pt-20">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20fashion%20product%20flatlay%20photography%20with%20white%20sneakers%20designer%20hoodies%20baseball%20caps%20leather%20bags%20and%20sunglasses%20neatly%20arranged%20on%20clean%20cream%20marble%20surface%2C%20soft%20natural%20window%20light%20casting%20gentle%20shadows%2C%20warm%20neutral%20beige%20and%20cream%20tones%2C%20minimalist%20editorial%20style%2C%20luxury%20product%20photography%2C%20elegant%20composition%2C%20no%20text%2C%20no%20watermark%2C%20high%20detail%20texture&width=1600&height=900&seq=hero-basetao-v2&orientation=landscape"
          alt="Basetao Spreadsheet - curated fashion products and shopping resource"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-16 md:py-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-6">
          <i className="ri-sparkling-line text-white/90 text-sm"></i>
          <span className="text-white/90 text-xs font-medium tracking-wide uppercase">Updated 2026 Resources</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5">
          Basetao Spreadsheet
          <br />
          <span className="text-white/85 font-normal italic text-2xl md:text-4xl lg:text-5xl">
            The Complete Resource Hub For Smarter Shopping
          </span>
        </h1>

        <p className="text-white/75 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
          Explore organized Basetao spreadsheets, product databases, shipping guides, warehouse tips and real user reviews — all in one powerful resource center designed to help you shop smarter and save money.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full text-base font-semibold whitespace-nowrap cursor-pointer transition-all duration-200 bg-primary-500 text-background-50 hover:bg-primary-600 hover:scale-105"
          >
            <i className="ri-external-link-line"></i>
            Basetao Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full text-base font-semibold whitespace-nowrap cursor-pointer transition-all duration-200 bg-white/15 backdrop-blur-sm border border-white/30 text-white hover:bg-white/25 hover:scale-105"
          >
            <i className="ri-shopping-bag-3-line"></i>
            Buy It Now
          </a>
        </div>

        <div className="max-w-md mx-auto">
          <label htmlFor="category-select" className="block text-white/70 text-sm mb-2 font-medium">
            Browse Product Categories
          </label>
          <div className="relative">
            <select
              id="category-select"
              value={selectedCategory}
              onChange={handleCategoryChange}
              className="w-full appearance-none bg-white/15 backdrop-blur-sm border border-white/25 text-white rounded-full py-3 px-5 pr-12 text-sm font-medium cursor-pointer focus:outline-none focus:ring-2 focus:ring-white/40 transition-all"
            >
              <option value="" className="text-foreground-900">Select a category...</option>
              {categories.map((cat) => (
                <option key={cat.name} value={cat.url} className="text-foreground-900">
                  {cat.name}
                </option>
              ))}
            </select>
            <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
              <i className="ri-arrow-down-s-line text-white/80"></i>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-8 text-white/60 text-xs">
          <span className="flex items-center gap-1.5"><i className="ri-check-line text-green-400"></i> Updated Resources</span>
          <span className="flex items-center gap-1.5"><i className="ri-check-line text-green-400"></i> Detailed Guides</span>
          <span className="flex items-center gap-1.5"><i className="ri-check-line text-green-400"></i> Shipping Cost Info</span>
          <span className="flex items-center gap-1.5"><i className="ri-check-line text-green-400"></i> Beginner Friendly</span>
        </div>
      </div>
    </section>
  );
}